import $ from 'jquery'

import colors from '../../../../lib/colors'

import { button, icon } from '../../../../component/component'

export function getTableDiv(value){

  if(value){
    var iconDiv =
      icon('fi-check',colors.green.s_500)
      .css({
        width: '20px',
        height: '20px',
        marginLeft: '8px',
        marginTop: '6px'
      })

  } else {
    var iconDiv =
      icon('fi-x',colors.red.s_500)
      .css({
        width: '20px',
        height: '20px',
        marginLeft: '8px',
        marginTop: '6px'
      })

  }

  var div =
    $('<div>')
    .append(iconDiv)

  return div

}

export function filterMatch(column,filter){

  if(filter == 'true'){
    return !!column.value
  } else if(filter == 'false'){
    return !!!column.value
  }

}

export function getFormField(o,p,field){

  if(field.value){
    var icon = 'fi-check'
    var color = colors.green.s_500
    var value = true
  } else {
    var icon = 'fi-x'
    var color = colors.red.s_500
    var value = false
  }

  var toggle = function(){
    value = !value
    if(value){
      iconDiv.setColor(colors.green.s_500)
      iconDiv.setIcon('fi-check')
    } else {
      iconDiv.setColor(colors.red.s_500)
      iconDiv.setIcon('fi-x')
    }
    p.change(field,value,true)
  }

  var labelDiv =
    button(field.id,null,true)
    .css({
      display: 'block',
    })

  var disabled = field.edit ? false : true

  var iconDiv =
    button(null,icon,disabled,color)
    .css({
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 0,
      borderTop: `1px solid ${colors.black}`,
      borderBottom: `1px solid ${colors.black}`,
    })

  if(!disabled){
    iconDiv.click(toggle)
  }

  var div =
    $('<div>')
    .css({
      position: 'relative'
    })
    .append(
      labelDiv,
      iconDiv,
    )

  requestAnimationFrame(function(){
    value = !value
    toggle()
  })

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/type/toggle/toggle.js